import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export function AuthCallback() {
  const navigate = useNavigate()
  const { setAuthData } = useAuthStore()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    const error = urlParams.get('error')

    if (error) {
      // * Redirect to login with error
      navigate('/login?error=oauth_failed')
      return
    }

    if (token) {
      // * Decode token to get user info (basic implementation)
      // * In production, you might want to call /api/auth/me to get full user data
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        
        // * Set token and basic user info
        // * We'll fetch full user data after setting token
        setAuthData(
          {
            id: payload.userId,
            email: payload.email,
            username: payload.email.split('@')[0],
            name: payload.email.split('@')[0],
            role: 'user',
            provider: 'google'
          },
          token
        )

        // * Fetch full user data
        fetch('/api/auth/me', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
          .then(res => {
            if (!res.ok) throw new Error('Failed to fetch user')
            return res.json()
          })
          .then(data => {
            if (data.user) {
              setAuthData(data.user, token)
            }
            navigate('/')
          })
          .catch((error) => {
            console.error('Error fetching user:', error)
            // * Still navigate to home, token is set
            navigate('/')
          })
      } catch (error) {
        console.error('Error processing token:', error)
        navigate('/login?error=invalid_token')
      }
    } else {
      navigate('/login?error=no_token')
    }
  }, [navigate, setAuthData])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  )
}

